import React, { useState } from 'react';

const TembungJawaWidget = props => {
    const all = props.annotation ?
        props.annotation.bodies.filter(b => ['jenistembung', 'lingga', 'imbuhan', 'garba'].includes(b.purpose)) : [];

    const [jenisTembung, setJenisTembung] = React.useState('andhahan');
    const [lingga, setLingga] = React.useState('');
    const [imbuhan, setImbuhan] = React.useState(['', '', '', '']);
    const [garba, setGarba] = React.useState(['', '', '']);
    const [body, setBody] = React.useState([]);

    const linggaRef = React.useRef(null);
    const garbaRef = React.useRef(null);

    const replaceDiakritik = (str) => {
        str = str.replace('e^', 'ê');
        str = str.replace('e`', 'è');
        str = str.replace('e_', 'è');
        return str;
    }

    const onChangeJenisTembang = (e) => {
        setJenisTembung(e.target.value);
    }

    const onChangeLingga = (e) => {
        setLingga(replaceDiakritik(e.target.value.toLowerCase()));
    }

    const updateImbuhan = (idx, value) => {
        var i = imbuhan;
        i[idx] = replaceDiakritik(value.toLowerCase());
        setImbuhan(i);
    }

    const updateGarba = (idx, value) => {
        let updated = garba;
        updated[idx] = replaceDiakritik(value.toLowerCase());
        setGarba(updated);
    }

    React.useEffect(() => {
        if (jenisTembung === 'andhahan') {
            linggaRef.current.focus();
        }
        if (jenisTembung === 'garba') {
            if (garbaRef.current)
                garbaRef.current.focus();
        }
    }, [jenisTembung])

    React.useEffect(() => {
        generateBody();
    }, [jenisTembung, lingga, imbuhan, garba]);

    React.useEffect(() => {
        linggaRef.current.focus();
        document.getElementById("r6o-input-lingga").focus();
        if (props.annotation.bodies.length === 0) return;
        setJenisTembung(props.annotation.bodies.filter(b => b.purpose == 'jenistembung')[0].value);

        if (props.annotation.bodies.filter(b => b.purpose == 'lingga').length > 0) {
            setLingga(props.annotation.bodies.filter(b => b.purpose == 'lingga')[0].value);
            linggaRef.current.focus();
        }

        if (props.annotation.bodies.filter(b => b.purpose == 'imbuhan').length > 0) {
            setImbuhan(props.annotation.bodies.filter(b => b.purpose == 'imbuhan')[0].value);
        }

        if (props.annotation.bodies.filter(b => b.purpose == 'garba').length > 0) {
            setGarba(props.annotation.bodies.filter(b => b.purpose == 'garba')[0].value);
        }
    }, [])

    const generateBody = () => {
        const generated = [
            {
                purpose: 'jenistembung',
                type: 'TextualBody',
                value: jenisTembung
            },
            {
                purpose: 'lingga',
                type: 'TextualBody',
                value: lingga
            }, {
                purpose: 'imbuhan',
                type: 'TextualBody',
                value: imbuhan
            }, {
                purpose: 'garba',
                type: 'TextualBody',
                value: garba
            }
        ];
        setBody(generated);
        const actions = [
            {
                action: 'upsert', body: {
                    purpose: 'jenistembung',
                    type: 'TextualBody',
                    value: jenisTembung
                }
            },
            {
                action: (jenisTembung != 'andhahan' ? 'remove' : 'upsert'), body: {
                    purpose: 'lingga',
                    type: 'TextualBody',
                    value: lingga
                }
            },
            {
                action: (jenisTembung != 'andhahan' ? 'remove' : 'upsert'), body: {
                    purpose: 'imbuhan',
                    type: 'TextualBody',
                    value: imbuhan
                }
            },
            {
                action: (jenisTembung != 'garba' ? 'remove' : 'upsert'), body: {
                    purpose: 'garba',
                    type: 'TextualBody',
                    value: garba
                }
            }
        ];
        props.onBatchModify(actions);
        // if (props.annotation.bodies.length === 0) {
        //     props.onAppendBody({ ...generated });
        // } else {
        //     props.onUpdateBody([], generated);
        // }
    }

    const onKeyDown = evt => {
        if (evt.which === 13)
            props.onSaveAndClose();
    }

    const onKeyDown2 = evt => {
        if (evt.altKey && evt.key === "z")
            setJenisTembung('andhahan')
        if (evt.altKey && evt.key === "x")
            setJenisTembung('garba')
        if (evt.altKey && evt.key === "c")
            setJenisTembung('stopword')
    }

    return (
        <div className="r6o-widget r6o-tembung-jawa" onKeyDown={onKeyDown2}>
            <div style={{ backgroundColor: "antiquewhite", padding: "10px" }}>
                <b>Catatan:</b><br />
                Untuk menulis <b>ê</b> ketikkan e^ dan untuk menulis <b>è</b> ketikkan e` atau e_
            </div>
            <b>Word : </b> <span>{props.annotation.quote}</span>
            <div className="radio">
                <label>
                    <input type="radio" name="jenis-tembung" value="andhahan" checked={jenisTembung === 'andhahan'} onChange={onChangeJenisTembang} onKeyDown={onKeyDown} />
                    Tembung Andhahan
                </label>
            </div>
            <div className="radio">
                <label>
                    <input type="radio" name="jenis-tembung" value="garba" checked={jenisTembung === 'garba'} onChange={onChangeJenisTembang} onKeyDown={onKeyDown} />
                    Tembung Garba
                </label>
            </div>
            <div className="radio">
                <label>
                    <input type="radio" name="jenis-tembung" value="stopword" checked={jenisTembung === 'stopword'} onChange={onChangeJenisTembang} onKeyDown={onKeyDown} />
                    Stop Word
                </label>
            </div>
            {jenisTembung == 'andhahan' && (<>
                <div>
                    <input type='text' id="r6o-input-lingga" placeholder='tembung lingga' ref={linggaRef} value={lingga} onKeyDown={onKeyDown} onChange={onChangeLingga} />
                </div>
                <div>
                    <input type='text' placeholder='imbuhan 1' value={replaceDiakritik(imbuhan[0])} onKeyDown={onKeyDown} onChange={e => updateImbuhan(0, e.target.value)} />
                </div>
                <div>
                    <input type='text' placeholder='imbuhan 2' value={imbuhan[1]} onKeyDown={onKeyDown} onChange={e => updateImbuhan(1, e.target.value)} />
                </div>
                <div>
                    <input type='text' placeholder='imbuhan 3' value={imbuhan[2]} onKeyDown={onKeyDown} onChange={e => updateImbuhan(2, e.target.value)} />
                </div>
                <div>
                    <input type='text' placeholder='imbuhan 4' value={imbuhan[3]} onKeyDown={onKeyDown} onChange={e => updateImbuhan(3, e.target.value)} />
                </div>
            </>)}
            {jenisTembung == 'garba' && (<>
                <div>
                    <input type='text' id="r6o-input-garba" placeholder='kata 1' ref={garbaRef} value={garba[0]} onKeyDown={onKeyDown} onChange={e => updateGarba(0, e.target.value)} />
                </div>
                <div>
                    <input type='text' placeholder='kata 2' value={garba[1]} onKeyDown={onKeyDown} onChange={e => updateGarba(1, e.target.value)} />
                </div>
                <div>
                    <input type='text' placeholder='kata 3' value={garba[2]} onKeyDown={onKeyDown} onChange={e => updateGarba(2, e.target.value)} />
                </div>
            </>)}
        </div>
    )

}

export default TembungJawaWidget;